module.exports = __webpack_public_path__ + "img/box_work.fe8017cb.png";